import React from "react";

const SquareIcon = ({
  size = 24,
  color = "#000000",
  strokeWidth = "2",
  fill = "none",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill={fill}></rect>
  </svg>
);

export default SquareIcon;
